
import { ProductEnum } from "@/utils/options";


const afnOptions = [
    {id: true, text: '亚马逊配送'},
    {id: false, text: '卖家自配送'},
]

const stateOption = [
    {id: 'Normal', text: '正常'},
    {id: 'Abnormal', text: '异常'},
]

export default () => [{
    prop: 'name',
    label: '视图名称',
    isFormItem: true,
    components() {
        return [{
            name: 'gj-input',
            prop: 'name',
            propsData: {
                placeholder: '请输入视图名称',
                style: {
                    width: '256px'
                }
            }
        }]
    },
    validator: [
        {required: true, message: '请输入视图名称', trigger: 'change'}
    ],
    labelWidth: '120px',
    defaultValue: ''
}, {
    label: '仓库',
    prop: 'warehouseIds',
    components: [{
        name: 'gj-warehouse-select',
        prop: 'warehouseIds',
        propsData: {
            multiple: true,
            self: false,
            placeholder: '仓库'
        },
        style: {
            width: '150px'
        }
    }],
    isFormItem: true,
    labelWidth: '120px',
    defaultValue: []
}, {
    label: '同步状态',
    prop: 'state',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'state',
        propsData: {
            options: stateOption,
            placeholder: '同步状态',
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '配送渠道',
    prop: 'afn',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'afn',
        propsData: {
            placeholder: '配送渠道',
            options: afnOptions
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
},{
    label: '产品类型',
    prop: 'productType',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-select',
        prop: 'productType',
        propsData: {
            placeholder: '产品类型',
            options: ProductEnum.typeOption
        },
        style: {
            width: '150px'
        }
    }],
    defaultValue: ''
}, {
    label: '品类',
    prop: 'categoryIds',
    isFormItem: true,
    labelWidth: '120px',
    components: [{
        name: 'gj-category-select',
        prop: 'categoryIds',
        propsData: {
            placeholder: '品类',
            multiple: true
        }
    }],
    defaultValue: []
}]
